import styled from 'styled-components';
import Colors from 'pubweb-smokey/dist/colors.js';
import {
  lg_mobile_breakpoint,
  tablet_portrait_breakpoint,
  tablet_landscape_breakpoint,
  sm_laptop_breakpoint,
  lg_laptop_breakpoint,
} from 'pubweb-smokey/dist/components/GridSystem/_vars_widths.js';

export const FullWidthFeatureCardStyles = styled.section`
  background-image: url(${(props) => props.$featuredImage});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  font-family: 'source-sans-pro', Helvetica, Arial, sans-serif;
  height: 560px;

  .full-width-card {
    height: 100%;
  }

  .card-overlay {
    background-color: rgba(0, 0, 0, 0.6);
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 0 15px 0 20px;
  }

  .card-desc {
    padding-bottom: 15px;
  }

  .card-link a {
    display: inline-block;
    text-decoration: none;
    vertical-align: middle;
    h4 {
      font-family: 'source-sans-pro', sans-serif;
    }
    svg {
      pointer-events: none;
      position: relative;
      top: 3px;
      left: 2px;
      path {
        fill: ${Colors.primary.white.standard};
      }
    }
  }

  h4 {
    line-height: 22px;
  }

  p {
    line-height: 26px;
  }

  h4,
  p {
    color: ${Colors.primary.white.standard};
    font-size: 18px;
  }

  @media screen and (min-width: ${lg_mobile_breakpoint}px) {
    p {
      line-height: 29px;
    }

    .card-overlay {
      padding: 0 35px;
    }
  }

  @media screen and (min-width: ${tablet_portrait_breakpoint}px) {
    .card-desc {
      padding-bottom: 29px;
    }

    .card-overlay {
      padding: 0 128px;
    }
  }

  @media screen and (min-width: ${tablet_landscape_breakpoint}px) {
    .card-overlay {
      padding: 0 385px 0 90px;
    }
  }

  @media screen and (min-width: ${sm_laptop_breakpoint}px) {
    .card-overlay {
      padding: 0 660px 0 60px;
    }
  }

  @media screen and (min-width: ${lg_laptop_breakpoint}px) {
    .card-overlay {
      padding: 0 798px 0 86px;
    }
  }
`;
